import __request__ from "routing/request";
export function get() {
  return __request__("GET", "/system/authentication/services/configuration", null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(JSONbody) {
  return __request__("POST", "/system/authentication/services/configuration", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
